import axios from "axios";
axios.defaults.headers["Content-Type"] =
  "application/x-www-form-urlencoded;charset=utf-8";
axios.defaults.withCredentials = true;
axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
let publicUrl = "";

// http://192.168.2.69/app
// http://mobile.docin.com/app

if (process.env.NODE_ENV === "development") {
  publicUrl = "https://mobile.docin.com/test";
}

if (process.env.NODE_ENV === "production") {
  // publicUrl = 'https://mobile.docin.com/test';
  publicUrl = "https://mobile.docin.com/app";
}

const $axios = axios.create({
  timeout: 100000,
  baseURL: publicUrl,
});

export default $axios;
